<nav class="navbar app-navbar" role="navigation" aria-label="Huvudnavigation">
  <div class="app-navbar-inner">
    <a class="app-brand" routerLink="/status" aria-label="WIUP startsida">
      <span class="app-brand-mark">W</span>
      <span>WIUP</span>
    </a>
    <div class="navbar-menu is-active">
    <div class="navbar-start">
      <div class="navbar-item has-dropdown is-hoverable">
        <a class="navbar-link" routerLink="/temperature" routerLinkActive="active">Temperatur</a>
        <div class="navbar-dropdown">
          <div class="navbar-item">
            <a routerLink="/temperature/6" routerLinkActive="active">Mässtensvägen - Utomhus</a>
          </div>
          <div class="navbar-item">
            <a routerLink="/temperature/1" routerLinkActive="active">Garage</a>
          </div>
          <div class="navbar-item">
            <a routerLink="/temperature/8" routerLinkActive="active">Garage-Förråd</a>
          </div>
          <div class="navbar-item">
            <a routerLink="/temperature/11" routerLinkActive="active">Norrbro</a>
          </div>
        </div>
      </div>

      <div class="navbar-item has-dropdown is-hoverable">
        <a class="navbar-link" routerLink="/energy" routerLinkActive="active">Energi</a>
        <div class="navbar-dropdown">
          <div class="navbar-item">
            <a routerLink="/energy" routerLinkActive="active">Nuvarande förbrukning</a>
          </div>
        </div>
      </div>

      <a class="navbar-item is-hoverable" routerLink="/pressure" routerLinkActive="active">Lufttryck</a>
      <a class="navbar-item is-hoverable" routerLink="/status" routerLinkActive="active">Status</a>

      @if (authGuard.isLoggedIn()) {
        <div class="navbar-item">
          <a routerLink="/schedule" routerLinkActive="active">Schemaläggning</a>
        </div>
      }

    </div>
    <div class="navbar-end">
      <button
        class="navbar-item theme-toggle"
        type="button"
        [attr.aria-label]="theme === 'light' ? 'Byt till mörkt tema' : 'Byt till ljust tema'"
        [attr.aria-pressed]="theme === 'dark'"
        (click)="toggleTheme()">
        <span class="theme-toggle-icon" aria-hidden="true">{{theme === 'light' ? '☾' : '☀'}}</span>
        <span>{{theme === 'light' ? 'Mörkt tema' : 'Ljust tema'}}</span>
      </button>
      @if (authGuard.isLoggedIn()) {
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link" routerLink="/user" routerLinkActive="active">{{authGuard.currentUser()}}</a>
          <div class="navbar-dropdown">
            <div class="navbar-item">
              <a routerLink="/logout" routerLinkActive="active">Logout</a>
            </div>
          </div>
        </div>
      }

      @if (!authGuard.isLoggedIn()) {
        <div class="navbar-item">
          <a routerLink="/login" routerLinkActive="active">Login</a>
        </div>
      }
    </div>
    </div>
  </div>
</nav>
<alert></alert>
<main class="app-shell">
  <router-outlet></router-outlet>
</main>
